import styles from './Circle.module.scss'

export const Circle = () => {
  return <div className={styles.circle} />
}
